/**
 * Music-track display helpers shared by NewJob (picker) and JobDetail
 * (Submitted Inputs panel). Kept in one place so the prettified name
 * matches everywhere — picking "Max-Richter_OnTheNature.mp3" should
 * read "Max Richter On The Nature" in BOTH screens, and updating the
 * rule (e.g. "preserve apostrophes") happens in one file.
 */

/** Filename → display name. Drops the extension, normalises common
 *  separators (`_` and `-`) to spaces, collapses runs of whitespace,
 *  and Title-Cases word boundaries. Examples:
 *    "acoustic-vibes.mp3" → "Acoustic Vibes"
 *    "Max Richter - On the Nature of Daylight.mp3"
 *      → "Max Richter   On The Nature Of Daylight"
 *      (the existing UI shows the raw filename underneath for cross-
 *       reference, so over-aggressive cleanup here would lose info).
 */
export function prettifyTrackName(filename: string): string {
  const stem = filename.replace(/\.[^.]+$/, "");
  return stem
    .replace(/[_-]+/g, " ")
    .replace(/\s+/g, " ")
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
